"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hoc = require("@apollo/client/react/hoc");
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _HomePageToggle = _interopRequireDefault(require("./HomePageToggle.render"));
var _apollo = require("../../apollo");
var _withAppConfig = _interopRequireDefault(require("../HOCs/withAppConfig"));
var _withHeaderApi = _interopRequireDefault(require("../HOCs/withHeaderApi"));
var _withLocale = _interopRequireDefault(require("../HOCs/withLocale"));
var _withUserAndPreferences = _interopRequireDefault(require("../HOCs/withUserAndPreferences"));
var _default = exports.default = (0, _flowRight.default)(_withLocale.default, _withAppConfig.default, _withHeaderApi.default, _withUserAndPreferences.default, (0, _hoc.graphql)(_apollo.setHp2MigrateMutation, {
  name: 'mutateHomepageToggle'
}))(_HomePageToggle.default);